import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { TreeSelect } from 'antd';
import classname from 'classnames';

const { TreeNode } = TreeSelect;
export default class treeSelect extends PureComponent {
  treeNode(data) {
    const options = this.props.options || [];
    const option = [
      options[0] ? options[0] : 'value',
      options[1] ? options[1] : 'name',
      options[2] ? options[2] : 'children',
      options[3] ? options[3] : 'isLeaf',
      options[4] ? options[4] : 'disableCheckbox',
      options[5] ? options[5] : 'hiddenCheckbox',
      options[6] ? options[6] : 'disabled'
    ];

    return data.map((item) => {
      if (item[option[2]] && item[option[2]].length > 0) {
        return (
          <TreeNode
            key={item[option[0]]}
            className={classname({
              'hidden-checkbox-tree': item[option[5]]
            })}
            disableCheckbox={item[option[4]] || item[option[5]]}
            disabled={item[option[6]]}
            record={item}
            title={item[option[1]]}
            value={item[option[0]]}
          >
            {this.treeNode(item[option[2]])}
          </TreeNode>
        );
      }
      return (
        <TreeNode
          key={item[option[0]]}
          className={classname({
            'hidden-checkbox-tree': item[option[5]]
          })}
          disableCheckbox={item[option[4]] || item[option[5]]}
          disabled={item[option[6]]}
          isLeaf={!item[option[3]]}
          record={item}
          title={item[option[1]]}
          value={item[option[0]]}
        />
      );
    });
  }

  render() {
    const { value, dataTreeSelect, name } = this.props;
    return (
      <TreeSelect
        // muc dich su dung "props.name": xac dinh element theo dropdownClassName (auto test)
        dropdownClassName={`tree-dropdown-${name}`}
        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
        showSearch={false}
        style={{ minWidth: 300, width: 300 }}
        treeNodeFilterProp="title"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...this.props}
        value={dataTreeSelect.length ? value : undefined}
      >
        {this.treeNode(dataTreeSelect)}
      </TreeSelect>
    );
  }
}

treeSelect.propTypes = {
  dataTreeSelect: PropTypes.arrayOf(PropTypes.any),
  // eslint-disable-next-line react/require-default-props
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array
  ]),
  options: PropTypes.arrayOf(PropTypes.any),
  // moi element trong mot form se co "name" khac nhau
  name: PropTypes.string
};

treeSelect.defaultProps = {
  options: undefined,
  name: '',
  dataTreeSelect: []
};
